'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FAQ = exports.Question = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n    margin-bottom: 1em;\n\n    line-height: 1.8em;\n\n    &:before {\n        content: \'\';\n        display: inline-block;\n        background: url(https://lib.tutellus.com/images/icons/small-question.svg) no-repeat center center;\n        padding: 2em 1.5em 2em 2.5em;\n        margin-left: -1em;\n        position: relative;\n        top: 1.5em;\n    }\n'], ['\n    display: block;\n    margin-bottom: 1em;\n\n    line-height: 1.8em;\n\n    &:before {\n        content: \'\';\n        display: inline-block;\n        background: url(https://lib.tutellus.com/images/icons/small-question.svg) no-repeat center center;\n        padding: 2em 1.5em 2em 2.5em;\n        margin-left: -1em;\n        position: relative;\n        top: 1.5em;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 0;\n  & > li {\n      list-style: none;\n      margin-top: -1em;\n      line-height: 1.5em;\n  }\n'], ['\n  padding: 0;\n  & > li {\n      list-style: none;\n      margin-top: -1em;\n      line-height: 1.5em;\n  }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var Question = exports.Question = _styledComponents2.default.strong(_templateObject);
Question.displayName = 'Question';
/*::
type Props = {|
    list?: Array<{|q: string, a: string|}>,
    children?: React.Node,
|}
*/
// $FlowFixMe
var FAQ /*: ComponentType<Props> */ = exports.FAQ = (0, _styledComponents2.default)(function (props) {
    return React.createElement(
        'ul',
        { className: props.className },
        props.children || props.list.map(function (faq, key) {
            return React.createElement(
                'li',
                { key: key },
                React.createElement(
                    Question,
                    null,
                    faq.q
                ),
                faq.a
            );
        })
    );
})(_templateObject2);
FAQ.displayName = 'FAQ';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/FAQ.js
// module id = 614
// module chunks = 0